import { ACTION_LOGOUT } from "@login/reducer/actions.type";
import {
  FETCH_PAYMENT_CARD_CREATE_REQUEST,
  FETCH_PAYMENT_CARD_CREATE_SUCCESS,
  FETCH_PAYMENT_CARD_CREATE_FAILURE,
  FETCH_PAYMENT_CARD_CONFIRM_REQUEST,
  FETCH_PAYMENT_CARD_CONFIRM_SUCCESS,
  FETCH_PAYMENT_CARD_CONFIRM_FAILURE,
  FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_REQUEST,
  FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_SUCCESS,
  FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_FAILURE,
  SET_PAYMENT_CARD_STORE,
  SET_PAYMENT_CARD_RESET,
} from "./actions.type";

import { PaymentCardState, PaymentCardActions } from "./types";

const initialState: PaymentCardState = {
  dataCreate: undefined,
  responseCreate: undefined,
  responseConfirm: undefined,
  responseAuth: undefined,
  isCreated: false,
  isConfirm: false,
  isAuthorization: false,
  errorOTP: false,
};

export default (state = initialState, action: PaymentCardActions): PaymentCardState => {
  switch (action.type) {
    case FETCH_PAYMENT_CARD_CREATE_REQUEST:
      return {
        ...state,
        dataCreate: action.payload,
        responseCreate: undefined,
        isCreated: false,
      };
    case FETCH_PAYMENT_CARD_CONFIRM_REQUEST:
      return {
        ...state,
        responseConfirm: undefined,
        isConfirm: false,
        errorOTP: false,
      };
    case FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_REQUEST:
      return {
        ...state,
        responseAuth: undefined,
        isAuthorization: false,
      };
    case FETCH_PAYMENT_CARD_CREATE_FAILURE:
    case FETCH_PAYMENT_CARD_CONFIRM_FAILURE:
      return {
        ...state,
      };
    case FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_FAILURE:
      return {
        ...state,
        errorOTP: action.payload,
      };
    case FETCH_PAYMENT_CARD_CREATE_SUCCESS:
      return {
        ...state,
        isCreated: true,
        responseCreate: action.payload,
      };
    case FETCH_PAYMENT_CARD_CONFIRM_SUCCESS:
      return {
        ...state,
        isConfirm: true,
        responseConfirm: action.payload,
      };
    case FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_SUCCESS:
      return {
        ...state,
        isAuthorization: true,
        responseAuth: action.payload,
      };
    case SET_PAYMENT_CARD_STORE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_PAYMENT_CARD_RESET:
      return {
        ...initialState,
      };
    case ACTION_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
